class UsersController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    new() {
        // Form submissions now handled by Stimulus user-form controller
        return;
    }

    edit() {
        console.log("users edit!");
    }
}

window.BC = window.BC || {};
window.BC.users = new UsersController();